module.exports = __webpack_public_path__ + "static/media/settings.931d2695.svg";